export const getType = value => {
  return Object.prototype.toString.call(value);
};
export const isString = value => {
  return getType(value) === "[object String]";
};
export const isArray = value => {
  return getType(value) === "[object Array]";
};
export const isObject = value => {
  return getType(value) === "[object Object]";
};
export const isNull = (object) => {
  return object === null || object === undefined;
};
export const isNullOrEmpty = (object) => {
  if (isNull(object) || object === '' || JSON.stringify(object) === '{}') {
    return true;
  }
  const type = getType(object);
  if (type === '[object Array]' && object.length === 0) {
    return true;
  }
  if (type === '[object Object]' && Object.keys(object).length === 0) {
    return true;
  }
  return type === '[object Set]' && object.size === 0;
};
export const isNullOrWhitespace = (object) => {
  return isNullOrEmpty(object) || /^\s*$/gi.test(object);
};
export const sleep = delay => {
  let timeout = null;
  let promise = new Promise(resolve => {
    timeout = setTimeout(resolve, delay);
  });
  promise.timeout = timeout;
  timeout = null;
  return promise;
};

export const nextTick = async callback => {
  return sleep(1000 / 30).then(() => {
    callback && callback();
  });
};
